import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useCurrencyUpdate } from '../contexts/CurrencyContext';
import getCountryCode from '../util/getCountry';
import {
  CODE_TO_COUNTRY,
  Country,
  CountryCode,
  COUNTRY_TO_CODE,
} from '../util/country';
import { useEffect, useState } from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { ImageOptimized } from './image/ImageOptimized';

const FlagImage = ({ country }) => {
  return (
    <Box
      sx={{
        mx: 2,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ImageOptimized
        style={{ borderRadius: '2px' }}
        src={`/assets/images/flags/${country.toLowerCase()}.svg`}
        width={41 * 1.5}
        height={26 * 1.5}
        alt={`${country} flag`}
      />
    </Box>
  );
};

const IconComponent = (props) => {
  return (
    <ArrowDropDownIcon
      className={props.className}
      sx={{
        color: '#4DC8FF !important',
        position: 'absolute',
        userSelect: 'none',
        pointerEvents: 'none',
        paddingRight: '0 !important',
      }}
    />
  );
};

export function SelectOutlinedCountry() {
  const { handleCountryChange, exchangeRatesReady } = useCurrencyUpdate();
  const [selectedCountry, setSelectedCountry] = useState<Country>('USA');
  useEffect(() => {
    if (!exchangeRatesReady) return;
    const countryCode =
      (localStorage.getItem('selectedCountry') as CountryCode) ||
      getCountryCode();
    setSelectedCountry(CODE_TO_COUNTRY[`${countryCode}`] || 'USA');
    handleCountryChange(countryCode);
    //having handleCountryChange in deps leads to infinite loop
    //I only want this to run on mount
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exchangeRatesReady]);
  const handleChange = (e: SelectChangeEvent) => {
    setSelectedCountry(e.target.value as Country);
    handleCountryChange(COUNTRY_TO_CODE[`${e.target.value}`]);
  };
  const countries = Object.keys(COUNTRY_TO_CODE);
  return (
    <Select
      size="small"
      sx={{
        paddingLeft: 0,
        '& .MuiSelect-select': {
          paddingRight: '0px !important',
        },
        minWidth: '70px',
        height: '38px',
      }}
      MenuProps={{
        sx: { maxHeight: '75vh' },
      }}
      variant="outlined"
      IconComponent={IconComponent}
      startAdornment={
        <FlagImage country={COUNTRY_TO_CODE[`${selectedCountry}`]} />
      }
      onChange={handleChange}
      value={''}
    >
      {countries.map((country) => {
        return (
          <MenuItem key={country} value={country}>
            {country}
          </MenuItem>
        );
      })}
    </Select>
  );
}
